import { EEventState, ICorrection } from '@turing/interfaces/event';
import { getRandomTime } from '@turing/helpers';

export const getCorrectionEventsAPI = (): Promise<ICorrection[]> => {
  let correctionData: ICorrection[] = [];

  const nowTime = new Date();

  const initialTodayData: ICorrection = {
    id: 10,
    summary: 'Spelling Corrections',
    url: 'https://example.com/correction1',
    state: EEventState.Pending,
    start: new Date(nowTime.setHours(nowTime.getHours() + 2)).toISOString(),
    end: new Date(nowTime.setHours(nowTime.getHours() + 1)).toISOString(),
  };
  correctionData.push(initialTodayData);

  for (let i = 1; i < 5; i++) {
    let previousData = correctionData[i - 1];
    let newStart = new Date(previousData.start);

    const randomTime = getRandomTime(newStart);
    let startTime = new Date(randomTime.setHours(randomTime.getHours() + 2));
    let endTime = new Date(startTime.getTime() + 60 * 60 * 1000);

    let newData: ICorrection = {
      id: previousData.id + 1,
      summary: `Correction ${previousData.id + 1}`,
      url: `https://example.com/correction${previousData.id + 1}`,
      state: i % 3 === 0 ? EEventState.Pending : i % 3 === 1 ? EEventState.InProgress : EEventState.Completed,
      start: startTime.toISOString(),
      end: endTime.toISOString(),
    };
    correctionData.push(newData);
  }

  return Promise.resolve(correctionData);
};
